import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { StructuredProcessIntroDoc } from 'src/app/moov-common/services/chat/strcutredProcess-data';

@Component({
  selector: 'app-structured-process-intro-component',
  templateUrl: './structured-process-intro-component.component.html',
  styleUrl: './structured-process-intro-component.component.scss'
})
export class StructuredProcessIntroComponentComponent  extends BaseComponent implements OnInit{
  @Input() doc!: StructuredProcessIntroDoc;
  @Output() action = new EventEmitter<"start"|"dismiss">();

  videoUrl: SafeResourceUrl = "";

  constructor(private sani: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.setVideoUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ifChanged(changes.doc, () => {
      this.setVideoUrl();
    });
  }

  setVideoUrl(){
    this.videoUrl = this.safeUrl(this.doc.hero?.src || "");
  }

  onAction(a: "start"|"dismiss"){ this.action.emit(a); }
  safeUrl(u: string): SafeResourceUrl { return this.sani.bypassSecurityTrustResourceUrl(u); }
}
